export default __webpack_public_path__ + "static/media/payment-success.39c98e06.svg";